import { api, setConfig, UPDATE_GAME_MESSAGE } from '../..';
import { mapEntityToApi } from './mapper';
import { PropertyType } from '../../../common';

export const editGame = (data: PropertyType): Promise<PropertyType> =>
	api.post('/games/update', mapEntityToApi(data), setConfig(data)).then((res) => {
		return { message: UPDATE_GAME_MESSAGE, game: res.data.data };
	});
